import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

// Whether the founder's assistant drawer is open (components/Assistant.jsx), what they're typing in it and the files
// they're importing with it. It sits above the routes, so the drawer keeps its conversation and the unsent message
// while the founder moves between pages; someone else signing in in this tab starts with it closed and empty.
const AssistantContext = createContext({ open: false, setOpen: () => {}, toggle: () => {}, draft: "", setDraft: () => {},
  files: [], setFiles: () => {} });

export function AssistantProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState("");
  const [files, setFiles] = useState([]);  // imported with the message being written (backend assistant_files.py)
  const who = useAuth()?.user?.id;
  useEffect(() => { setOpen(false); setDraft(""); setFiles([]); }, [who]);
  const value = { open, setOpen, toggle: () => setOpen((o) => !o), draft, setDraft, files, setFiles };
  return <AssistantContext.Provider value={value}>{children}</AssistantContext.Provider>;
}

export const useAssistant = () => useContext(AssistantContext);
